// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-09T15:23:02.509Z
// Property: Prestige (ID: 6767906449167741)
// Collections: 24 amenities, 20 floorplans (live), 10 photos, 72 POIs, 5 reviews, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167741",
  "property_external_id": "hv9byb3",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/the-prestige-at-palm-aire-pompano-beach-fl/hv9byb3/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "prestige",
  "property_name": "Prestige",
  "property_website_url": "http://prestige-theme-preview.multiscreensite.com/",
  "property_domain": null,
  "property_address": "300 Broward Blvd",
  "property_full_address": "300 Broward Blvd",
  "property_address_1": "3880 W Broward Blvd",
  "property_address_2": null,
  "property_address_city": "Fort Lauderdale",
  "property_address_state": "FL",
  "property_address_zip_full": null,
  "property_address_zip": "33312",
  "property_address_country": "US",
  "property_address_county": "Broward County",
  "property_neighborhood_address": "Palm Aire",
  "property_address_latitude": "26.1203376",
  "property_address_longitude": "-80.20044560000001",
  "property_email": null,
  "property_phone": "1234567890",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Brand-new luxury living. The Prestige offers pet-friendly studio, one, two, and three bedroom homes with polished finishes, everyday convenience, and curated spaces for modern downtime—schedule your tour today.</p>",
  "property_long_description": "<p>Welcome to The Prestige, an exquisite rental community where luxury living meets the vibrant energy of North Fort Lauderdale. Nestled within the prestigious golf course community, our high-end townhomes offer a refined lifestyle like no other. Discover the epitome of elegance in our spacious 2, 3, and 4-bedroom units, meticulously crafted to provide both comfort and style. Ranging from 1800 to 2300 square feet, each home boasts ample space for luxurious living. Every unit also features a coveted car garage, ensuring secure parking and added convenience for residents. Immerse yourself in the tranquil ambiance of our trendy community, where relaxation and recreation await at every turn. Dive into the inviting waters of our pristine pool, surrounded by lush greenery and the gentle rustle of palm trees. Whether you seek a refreshing swim or simply wish to unwind under the sun, our pool area provides the perfect oasis for residents to enjoy. Step outside your doorstep and embrace the beauty of Prestige's renowned golf course, offering breathtaking views and endless opportunities for outdoor leisure. With scenic landscapes and abundant amenities at your fingertips, every day presents a new adventure waiting to be discovered. Located in the vibrant North Fort Lauderdale area, \"The Prestige\" offers easy access to shopping, dining, entertainment, and major highways, ensuring that residents enjoy the best of both worlds: serenity and convenience. At \"The Prestige,\" luxury extends beyond the confines of your home, enriching every aspect of daily life. Experience the ultimate in comfort, convenience, and sophistication in this exclusive rental community. Welcome to a lifestyle of prestige and refinement at \"The Prestige.\"</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-9421-746f-93ce-021ad73f2e80.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with cabanas, lounge chairs, and a pink flamingo float.",
    "public_id": "01a03e5b-9421-746f-93ce-021ad73f2e80",
    "storage_key": "property/6767906449167741/01a03e5b-9421-746f-93ce-021ad73f2e80.webp",
    "width": 2048,
    "height": 1367
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "39",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": null,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Pets up to 100 lbs are welcome. Restricted breeds may apply.",
  "property_pet_policy_description": "We welcome pets up to 100 lbs. Restricted breeds may apply—please contact us for details.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-3e41-7219-8d51-927b6a7a757f.webp",
  "property_primary_logo_media": null,
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-3e80-73ca-beff-067cf1910e7e.webp",
  "property_fav_icon_media": {
    "alt_text": "Prestige logo",
    "public_id": "01a03e5a-3e80-73ca-beff-067cf1910e7e",
    "storage_key": "property/6767906449167741/01a03e5a-3e80-73ca-beff-067cf1910e7e.webp",
    "width": 240,
    "height": 166
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-3e41-7219-8d51-927b6a7a757f.webp",
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-780f-73fc-84b3-e834ae4ee573.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03e5a-780f-73fc-84b3-e834ae4ee573",
    "storage_key": "property/6767906449167741/01a03e5a-780f-73fc-84b3-e834ae4ee573.webp",
    "width": 500,
    "height": 345
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#282424",
  "property_secondary_color": "#bc6e2a",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#fae0c0",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 4",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2 - 3",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "3",
  "property_sqft_range": "1,783 - 2,258 sq ft",
  "property_sqft_min": "1,783",
  "property_sqft_max": "2,258",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJH8jANyUH2YgRmq_vKXSN5s4",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Prestige",
  "property_home_romance_title": "Embrace the Life You Love at Our Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Downtime comes with options.</strong> Cool off by the pool, unwind beneath the cabana, follow the walking trails, or get moving on the tennis, basketball, racquetball, and volleyball courts. Back at home, everyday details like in-home laundry, stainless steel appliances, quartz countertops, pantry storage, and a private patio keep your routine polished and practical.</p>",
  "property_home_floorplans_blurb": "<p><strong>Townhome-style space, streamlined search.</strong> Explore two-, three-, and four-bedroom layouts with open living areas, defined dining space, in-home washer and dryer, quartz countertops, stainless steel appliances, pantry storage, and a private patio. Compare pricing and availability, find the flow that fits your routine, and take the next step toward touring Prestige in Fort Lauderdale.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Prestige.</strong> Preview bright interiors with quartz countertops, stainless steel appliances, clean tile or vinyl flooring, dining areas, and patios that open the space outdoors. Then explore the community scenes—from the pool and cabana to courts and landscaped paths in a Palm Aire setting—and see how polished finishes and everyday amenities come together.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Map out a Broward Boulevard home base.</strong> From Prestige, daily stops, Marthabrae Jamaican Restaurant, and Plantation Walk’s restaurant-and-retail scene are close by, with Secret Woods Nature Center offering a quieter South Florida reset. BCT service, Tri-Rail, I-595, and the Turnpike help keep downtown Fort Lauderdale, University Drive, and Sawgrass Mills within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Prestige earns praise for service that shows up.</strong> Residents call out responsive communication, helpful tours and questions with Esther and Manny, and maintenance support from Britt and Adrian that gets things done. Reviews also point to clean, well-kept surroundings, a beautiful pool, and a community experience that feels true to what’s promised: <strong>“what you see is actually what you get.”</strong></p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map, then follow your mood.</strong> Around Prestige, Broward Boulevard gives you a practical Fort Lauderdale home base with quick access to daily stops, Caribbean flavors at nearby Marthabrae Jamaican Restaurant, and the growing restaurant-and-retail scene at Plantation Walk. When you want time outdoors, point yourself toward Secret Woods Nature Center for a quieter South Florida reset, or head west for shopping, dining, and entertainment along University Drive.</p><p>BCT service on Broward Boulevard, the Fort Lauderdale Tri-Rail station, I-595, and the Turnpike keep the wider area within reach, from downtown Fort Lauderdale to Sawgrass Mills. Explore the points on the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Prestige connects everyday convenience with West Broward energy.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Your downtime has options here.</strong> At Prestige, amenities are designed to make home feel easy, active, and polished—whether you’re cooling off by the pool, relaxing under the cabana, taking a walk along the trails, or moving between tennis, basketball, racquetball, and volleyball courts in the Palm Aire setting.</p><p>Inside, your space keeps the same everyday practicality with an in-home washer and dryer, ceiling fans, a private patio, and a kitchen finished with stainless steel appliances, quartz countertops, pantry storage, dishwasher, disposal, and ice maker. Controlled access and a fenced lot add another layer of convenience, while clean tile and vinyl flooring keep the look fresh. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Prestige at Palm Aire home?</strong> Start your application online for spacious 2-, 3-, and 4-bedroom townhomes with refined finishes, generous layouts, and garage parking—all set within a tranquil golf course community in vibrant North Fort Lauderdale.</p>",
  "property_contactus_blurb": "<p><strong>Connect with The Prestige at Palm Aire.</strong> Have questions or need directions? Our leasing team is here to help you explore refined townhome living in North Fort Lauderdale, from spacious 2-, 3-, and 4-bedroom layouts to everyday convenience. Reach out today or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Prestige at Palm Aire?</strong> Find quick answers about our refined rental community, spacious townhomes, leasing details, and everyday living in North Fort Lauderdale. If you need anything else, the leasing team is happy to help you take the next step with confidence.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits your everyday rhythm.</strong> Prestige offers spacious two-, three-, and four-bedroom townhome-style floor plans with room to spread out, gather, work, and unwind. Compare available homes by layout, pricing, and availability, then look for the details that make daily living feel polished: open living areas, defined dining space, in-home washer and dryer, quartz countertops, stainless steel appliances, pantry storage, and a private patio.</p><p>Whether you want extra bedrooms, a larger kitchen flow, or more separation between living and sleeping areas, these layouts give you options without overcomplicating the search. Browse the floor plan cards below, explore finishes in the <a href=\"/gallery\">photo gallery</a>, and <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see your next home in person.</p>",
  "property_gallery_blurb": "<p><strong>See Prestige from the inside out.</strong> Browse the gallery for the details that make each space feel bright, polished, and ready to enjoy—from quartz countertops and stainless steel appliances to clean tile or vinyl flooring, dining areas, and patios that extend your living space outdoors.</p><p>As you move through the photos, picture sunny afternoons by the pool and cabana, a quick match on the courts, or a quiet walk through the landscaped paths around the Palm Aire setting. The images give you a closer look at the balance of comfort and activity throughout the community without needing to imagine it from a floor plan alone. Explore the finishes, compare the feel of each space, then view more <a href=\"/amenities\">community features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Prestige in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Prestige at Palm Aire on the map.</strong><br>See available 2, 3, and 4-bedroom townhomes within the Palm Aire golf course community, then zoom out to discover nearby shopping, dining, entertainment, and major highway access across vibrant North Fort Lauderdale.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living starts with easier daily routines.</strong> At Prestige, your pet has room to settle in with you, from spacious townhome-style layouts to practical finishes like tile or vinyl flooring, an in-home washer and dryer, and a patio that adds a little fresh-air space to your day.</p><p>Step outside for a walk along the community’s walking and biking trails, enjoy the added convenience of a fenced setting and controlled access, and find everyday pet care, supplies, and dog-friendly outdoor options around the Palm Aire area. Pets up to 100 lbs are welcome; because breed restrictions may apply, the leasing team can help confirm the details before you apply. Explore more <a href=\"/amenities\">community features</a> or <a href=\"/contact-us\">contact the leasing team</a> with pet policy questions.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Prestige lifestyle.</strong> Love the spacious townhomes, refined finishes, garage convenience, and tranquil poolside setting? Invite a friend to discover luxury living in North Fort Lauderdale with room to unwind, easy everyday access, and <a href=\"/floor-plans\">2-, 3-, and 4-bedroom layouts</a> designed for comfort and style.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Prestige at Palm Aire.</strong><br>Luxury and convenience continue here. Log in to pay rent, submit maintenance requests, and manage your account with ease—so daily living in your spacious townhome stays as refined and effortless as the community around you.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Prestige.</strong> As you read through the reviews, you’ll notice a clear theme: responsive service, welcoming interactions, and a community that’s cared for day to day.</p><p>Residents frequently praise team members like Esther and Manny for making tours and questions feel easy, informed, and genuinely helpful, while Britt and Adrian are recognized for maintenance support that gets things done. Reviews also highlight clean, well-maintained surroundings, a beautiful pool, and communication that keeps residents in the loop. One resident summed it up simply: <strong>“what you see is actually what you get.”</strong></p>",
  "property_created_at": "1787752406807",
  "property_scheduletour_blurb": "<p><strong>See Prestige at Palm Aire in person.</strong> Tour spacious 2, 3, and 4-bedroom townhomes with 1,800–2,300 square feet, coveted garages, and a tranquil pool setting within the Palm Aire golf course community. <a href=\"/contact-us\">Schedule your tour</a> and experience the comfort, convenience, and refinement firsthand.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon to help you explore The Prestige at Palm Aire, where spacious 2, 3, and 4-bedroom townhomes, garage convenience, a serene pool setting, and Palm Aire golf course surroundings bring refined North Fort Lauderdale living within reach.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Prestige",
  "property_seo_title_home": "Prestige |  Apartments in Fort Lauderdale, FL",
  "property_seo_description_home": "Experience luxury living at Prestige in Fort Lauderdale, FL! Enjoy modern amenities like pools, sports courts, and stylish interiors. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Fort Lauderdale, FL Apartments for Rent",
  "property_seo_description_floorplans": "Unveil your ideal living space at Prestige in Fort Lauderdale. Check out our one-bedroom floor plans and let your new home inspire a life of comfort and style!",
  "property_seo_title_amenities": "Amenities | Fort Lauderdale, FL Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Prestige in Fort Lauderdale. Enjoy top-notch amenities like a pool, tennis courts, and modern interiors. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Fort Lauderdale, FL",
  "property_seo_description_gallery": "Picture your life at Prestige in Fort Lauderdale! Enjoy stunning amenities, stylish floor plans, and a vibrant community. Discover your dream lifestyle today!",
  "property_seo_title_virtualtours": "Virtual Tours | Prestige Apartments",
  "property_seo_description_virtualtours": "Experience luxury living at Prestige in Fort Lauderdale! Dive into our one-bedroom floor plans and take an exclusive virtual tour of your future home!",
  "property_seo_title_interactivemap": "Interactive Map | Prestige Apartments",
  "property_seo_description_interactivemap": "Discover your haven at Prestige in Fort Lauderdale—modern living, top-tier amenities, and interactive maps make apartment hunting easy!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Fort Lauderdale, FL",
  "property_seo_description_neighborhood": "Experience Fort Lauderdale living at Prestige! Uncover local favorites, vibrant hotspots, and everything our welcoming neighborhood has to offer.",
  "property_seo_title_contact": "Contact Us | Prestige",
  "property_seo_description_contact": "Connect with Prestige in Fort Lauderdale! Inquire about our stylish one-bedroom floor plans and let our leasing team guide your next home journey.",
  "property_seo_title_faqs": "FAQs | Apartments in Fort Lauderdale, FL",
  "property_seo_description_faqs": "Get the scoop on living at Prestige in Fort Lauderdale! Dive into our FAQs to learn about amenities, floor plans, and all the perks that await you.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Fort Lauderdale, FL",
  "property_seo_description_reviews": "Experience life at Prestige in Fort Lauderdale, where vibrant amenities meet stylish living. Check out resident reviews to see why they love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Fort Lauderdale, FL",
  "property_seo_description_applynow": "Discover your haven at Prestige in Fort Lauderdale! Enjoy modern 1-bedroom layouts, a pool, tennis courts, and serene trails. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Prestige",
  "property_seo_description_residentaccess": "Login to your Prestige resident portal in Fort Lauderdale, FL. Easily pay rent, schedule maintenance, and take control of your community experience!",
  "property_seo_title_referafriend": "Refer A Friend | Prestige",
  "property_seo_description_referafriend": "Refer a friend to Prestige in Fort Lauderdale! Great friends make great neighbors—join our vibrant community today and enjoy life to the fullest!",
  "property_seo_title_scheduletour": "Schedule a Tour | Prestige",
  "property_seo_description_scheduletour": "Experience the charm of Prestige in Fort Lauderdale. Schedule a tour today and picture your new life in luxury living just steps from sun-soaked beaches!",
  "property_seo_title_privacy": "Privacy Policy | Prestige",
  "property_seo_description_privacy": "At Prestige in Fort Lauderdale, your privacy matters. Dive into our commitment to safeguarding your information and learn about our privacy practices today!",
  "property_seo_title_accessibility": "Website Accessibility | Prestige",
  "property_seo_description_accessibility": "At Prestige in Fort Lauderdale, we champion digital accessibility for all. Dive into our commitment to inclusivity and seamless living experiences today!",
  "property_seo_title_sitemap": "Sitemap | Prestige",
  "property_seo_description_sitemap": "Discover the layout of Prestige in Fort Lauderdale, FL, with our sitemap to effortlessly find your ideal apartment in our vibrant community!",
  "property_seo_title_thankyou": "Thank You | Prestige",
  "property_seo_description_thankyou": "Thank you for reaching out to Prestige in Fort Lauderdale! Our team will connect with you soon to help you find your perfect apartment home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Fort Lauderdale, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787754936794",
  "amenities": [
    {
      "id": "ec_f01ef0a6c6c8193d093b7553",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9627718b5d9eaa3049470626",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Fenced Lot",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fab5a4ceff320157c85075b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d0455de788005e09e9f6278",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_820e96c89441842900f49bad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76829ab679a4ce461fbeb9a3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ef240d460487fa1bac8d95d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c14d7cea0ddddad91b9609b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Racquetball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_523cb7a8e419d9b372314395",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f1f73cbe640d4c1efb7dbd7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Walking/Biking Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f16d09a1baf0cdb00ef2ee5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Golf Course",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24e4828efdbcc182128ff455",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa186fb573ca3dc40c5ee26c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57d2f148102370b40d992ca5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6db390f8a42a11d181cd2de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee0b59471e6b944d9ed8e21e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4f6d3f554b303485aa400df",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86d5aea7486b8427c1a4bd13",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b103843844b342bdd9b0a5e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8735bf38c2c159999638a83c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8dfcc4b0f226e8e8fd56178",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_812f6c71a69ff39b27a89ed6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0edf36bed116394de37bd2b1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6abc8b22015d95451922a3c7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_b82e03b8fc4e114d39d3aecb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-a020-73b8-97db-ae72e50e1f03.webp",
      "image_media": {
        "alt_text": "Leasing center entrance with fountain and pool in the background.",
        "public_id": "01a03e59-a020-73b8-97db-ae72e50e1f03",
        "storage_key": "property/6767906449167741/01a03e59-a020-73b8-97db-ae72e50e1f03.webp",
        "width": 2089,
        "height": 1392
      },
      "title": "Community",
      "description": "Welcome to the leasing center and enjoy the beautiful landscaping and amenities this community has to offer.",
      "link": "false",
      "alt_text": "Leasing center entrance with fountain and pool in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "ec_cd40b76f22a3527b033cde16",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-9d4f-7171-9160-790f3b669af0.webp",
      "image_media": {
        "alt_text": null,
        "public_id": "01a03e59-9d4f-7171-9160-790f3b669af0",
        "storage_key": "property/6767906449167741/01a03e59-9d4f-7171-9160-790f3b669af0.webp",
        "width": 1543,
        "height": 1030
      },
      "title": "false",
      "description": "false",
      "link": "false",
      "alt_text": "false",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "ec_1b207e5bbb537e09ebf3468f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-3b09-74df-a4c9-8aa6a682418e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "01a03e5a-3b09-74df-a4c9-8aa6a682418e",
        "storage_key": "property/6767906449167741/01a03e5a-3b09-74df-a4c9-8aa6a682418e.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the resort-style pool. Lounge chairs and lush palm trees create a tropical oasis.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "ec_8a73e1473083240f1eb99634",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-a244-77bc-bf15-97c8ecd9f97a.webp",
      "image_media": {
        "alt_text": "Clean and modern bathroom with white vanity, tub, and shower.",
        "public_id": "01a03e59-a244-77bc-bf15-97c8ecd9f97a",
        "storage_key": "property/6767906449167741/01a03e59-a244-77bc-bf15-97c8ecd9f97a.webp",
        "width": 2598,
        "height": 1732
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed bathrooms, featuring elegant finishes and ample space for relaxation.",
      "link": "false",
      "alt_text": "Clean and modern bathroom with white vanity, tub, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "ec_e63116837fa32b13e221a9b9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-ac1b-77d9-930e-7a4a3c861bd4.webp",
      "image_media": {
        "alt_text": "Lobby area with seating and a coffee bar.",
        "public_id": "01a03e59-ac1b-77d9-930e-7a4a3c861bd4",
        "storage_key": "property/6767906449167741/01a03e59-ac1b-77d9-930e-7a4a3c861bd4.webp",
        "width": 2685,
        "height": 1790
      },
      "title": "Community",
      "description": "Enjoy our beautiful lobby area, featuring comfortable seating and a convenient coffee bar.",
      "link": "false",
      "alt_text": "Lobby area with seating and a coffee bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "ec_fe941928f000fa695981ff71",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-a7d4-70e4-96a6-3cb0f078a10f.webp",
      "image_media": {
        "alt_text": "Modern lounge area with communal tables, bar seating, and a coffee station.",
        "public_id": "01a03e59-a7d4-70e4-96a6-3cb0f078a10f",
        "storage_key": "property/6767906449167741/01a03e59-a7d4-70e4-96a6-3cb0f078a10f.webp",
        "width": 2655,
        "height": 1770
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish lounge, featuring comfortable seating, a well-equipped coffee bar, and ample space for community gatherings.",
      "link": "false",
      "alt_text": "Modern lounge area with communal tables, bar seating, and a coffee station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "ec_f4577e5710f609662d8bc7ab",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-ce8a-754d-8c15-3a700f435d59.webp",
      "image_media": {
        "alt_text": "Treadmills and ellipticals in a modern apartment complex gym with a pool view.",
        "public_id": "01a03e59-ce8a-754d-8c15-3a700f435d59",
        "storage_key": "property/6767906449167741/01a03e59-ce8a-754d-8c15-3a700f435d59.webp",
        "width": 2686,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, ellipticals, and a recumbent bike. Enjoy views of the sparkling swimming pool while you work out.",
      "link": "false",
      "alt_text": "Treadmills and ellipticals in a modern apartment complex gym with a pool view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "ec_135a0905c6baa6e30904c587",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-a056-7335-a762-66f0466770fd.webp",
      "image_media": {
        "alt_text": "Gym with cardio and weight machines, weight rack, and battle ropes.",
        "public_id": "01a03e59-a056-7335-a762-66f0466770fd",
        "storage_key": "property/6767906449167741/01a03e59-a056-7335-a762-66f0466770fd.webp",
        "width": 2688,
        "height": 1790
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide array of cardio machines, weight training equipment, and functional training tools.",
      "link": "false",
      "alt_text": "Gym with cardio and weight machines, weight rack, and battle ropes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "ec_40af0687f674e21056004382",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-c32e-76fe-86af-f50b2638c3e3.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and a stylish bar.",
        "public_id": "01a03e59-c32e-76fe-86af-f50b2638c3e3",
        "storage_key": "property/6767906449167741/01a03e59-c32e-76fe-86af-f50b2638c3e3.webp",
        "width": 2680,
        "height": 1782
      },
      "title": "Community",
      "description": "Relax and socialize in our inviting lounge, featuring contemporary decor and a fully equipped bar area.",
      "link": "false",
      "alt_text": "Modern lounge area with comfortable seating and a stylish bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "ec_b5ab777569562e296e7170a1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-a245-741b-b7a8-3212be5682df.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, TRX straps, yoga mats, and stability balls.",
        "public_id": "01a03e59-a245-741b-b7a8-3212be5682df",
        "storage_key": "property/6767906449167741/01a03e59-a245-741b-b7a8-3212be5682df.webp",
        "width": 2687,
        "height": 1791
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art weight machines, TRX suspension trainers, and a variety of exercise balls and mats for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, TRX straps, yoga mats, and stability balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_8560274941b9185a78a48d21",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "CRACK'D Kitchen & Coffee",
      "poi_type": "Restaurants",
      "poi_address": "331 N University Dr, Plantation, FL 33324, USA",
      "poi_short_description": "Relaxed spot for gourmet breakfast sandwiches and burritos, plus coffees, lattes and smoothies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-f044-73cc-bc83-1ab2422cf583.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f044-73cc-bc83-1ab2422cf583",
        "storage_key": "property/6767906449167741/01a03e5b-f044-73cc-bc83-1ab2422cf583.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crackdkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12527741535574775049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crackd-kitchen--coffee",
      "poi_latitude": "26.124609",
      "poi_longitude": "-80.257521",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 754-755-5445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfBh-J0H2YgRCVXXQY16260",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_5df359734fa0d17d3956c779",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Tacocraft Taqueria & Tequila Bar",
      "poi_type": "Restaurants",
      "poi_address": "301 N University Dr, Plantation, FL 33324, USA",
      "poi_short_description": "Trendy Mexican eatery offering tacos, quesadillas & tequila in a colorful space with outdoor seats.",
      "poi_long_description": "Trendy Mexican eatery offering tacos, quesadillas & tequila in a colorful space with outdoor seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-c513-7716-9314-3f43cc4726a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-c513-7716-9314-3f43cc4726a7",
        "storage_key": "property/6767906449167741/01a03e5b-c513-7716-9314-3f43cc4726a7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tacocraft.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11353178305732056895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacocraft-taqueria--tequila-bar",
      "poi_latitude": "26.1245124",
      "poi_longitude": "-80.25602049999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-999-5559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7bwDscH2YgRP5fUcISXjp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_b261be12d2367cda14b7fdfc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Ford's Garage Plantation",
      "poi_type": "Restaurants",
      "poi_address": "301 N University Dr Ste 600, Plantation, FL 33324, USA",
      "poi_short_description": "Vivid, automotive-themed eatery serving burgers beer and craft cocktails from a bar stocked with local brews and taps.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-c54a-756c-9ea8-d45868277c7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-c54a-756c-9ea8-d45868277c7d",
        "storage_key": "property/6767906449167741/01a03e5b-c54a-756c-9ea8-d45868277c7d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fordsgarageusa.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=1597122789705467107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fords-garage-plantation",
      "poi_latitude": "26.1249778",
      "poi_longitude": "-80.25666989999999",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 754-714-3673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7y-kNcH2YgR40QTH7ceKhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_666074eaca2d972c718ee74e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Un Attimo Specialty Coffee",
      "poi_type": "Restaurants",
      "poi_address": "331 N University Dr M2-100, Plantation, FL 33324, USA",
      "poi_short_description": "Pet-friendly bakery with a chic vibe for coffee, muffins, pastries and sandwiches made on-site and served by friendly staff and owners, as well as desserts and savory fare for breakfast and lunch.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-b656-7612-980d-f8906403b028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-b656-7612-980d-f8906403b028",
        "storage_key": "property/6767906449167741/01a03e5b-b656-7612-980d-f8906403b028.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://unattimocoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313285114726119252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "un-attimo-specialty-coffee",
      "poi_latitude": "26.1243374",
      "poi_longitude": "-80.2575697",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 754-457-2147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-aede-7537-b899-8eeb2d51ade4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-aede-7537-b899-8eeb2d51ade4",
        "storage_key": "property/6767906449167741/01a03e5c-aede-7537-b899-8eeb2d51ade4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJB6p1jv4H2YgRVPcuy3dvP4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_3e9aac719c4bd47b8dd3b351",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Cajun Boil Seafood Restaurant Plantation",
      "poi_type": "Restaurants",
      "poi_address": "8000 W Broward Blvd Ste 1329, Plantation, FL 33388, USA",
      "poi_short_description": "Casual eatery featuring seafood boil steamed in Asian-infused Cajun spices, plus fried dishes, wings and gumbo.",
      "poi_long_description": "false",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ1yWQ3SYH2YgRpyOMdd038Ws/photos/AVoNoXRS5hxOd9AmtGsTHpPLQ0c0872ijUm91HSezEDbfn5V8xRPwLuo9FEZ0MODszbOoVMd0pNeApEGAorLjLIzSVPov9-DxXM62-yoOL4ksiTqEZ7NxScAKBy9_CjE88Yc4R5W3SBqlbJSxvNPHnr6Un-hA63bb4KJgfMoMmbbSqN-8_RGBb7W7RbaFyJb9qijRhRrMwQFuPYoFHmMIZlDM3lgRAoZEmOA4vwKVp9rchCNTbR5bH3yQopW3XliqJQp3JypwfhVMMuHkkAGxr1CwIsTX0_R9UrgqtBVfLqrBsiDR0lEQWSMg0UHC0nHr2YSv2JnucER3HThDJokfGf6QdLHmuU2mfSTR_6pLgX5sp6L2wMbypp2MCLxGsnR41IFsqj_iFfYaeUpBsWwoGOw2VPU1IY3dT8wVTfhDEVLUCVnMqkHW-o7XWu_7qoxlA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4800&maxHeightPx=3393",
      "poi_featured_image_media": null,
      "poi_business_url": "https://cajunboil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7778059455744975783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cajun-boil-seafood-restaurant-plantation",
      "poi_latitude": "26.1173529",
      "poi_longitude": "-80.25534309999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-474-8009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1yWQ3SYH2YgRpyOMdd038Ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_46de04c5931b294765364326",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Marthabrae Jamaican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3951 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Casual spot dishing up Jamaican dishes for breakfast, lunch and dinner, plus desserts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-c585-7307-83b4-52191f8bc0ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-c585-7307-83b4-52191f8bc0ce",
        "storage_key": "property/6767906449167741/01a03e5b-c585-7307-83b4-52191f8bc0ce.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.marthabrae.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8212373872776689238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marthabrae-jamaican-restaurant",
      "poi_latitude": "26.1230076",
      "poi_longitude": "-80.2014375",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 954-306-2485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCX48KCUH2YgRVraNuYY2-HE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "caribbean_restaurant"
    },
    {
      "id": "ec_19a7bc68997b679781450b8b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Dutch Pot Restaurant - Fort Lauderdale",
      "poi_type": "Restaurants",
      "poi_address": "3120 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Casual, counter-service eatery and drive-thru dishing up a wide-ranging menu of Jamaican eats from Jerk-spiced options to stews to patties, as well as juices.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-c5fe-76f8-9cf9-7f5c750ebe5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-c5fe-76f8-9cf9-7f5c750ebe5d",
        "storage_key": "property/6767906449167741/01a03e5b-c5fe-76f8-9cf9-7f5c750ebe5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dutchpotrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5468518179769600810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-pot-restaurant---fort-lauderdale",
      "poi_latitude": "26.1209934",
      "poi_longitude": "-80.1870524",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 954-533-2160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ79H4i7sB2YgRKsvuoE8U5Es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_476c6c7e910a84274ba6e50e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Restaurante GastroBar Latino",
      "poi_type": "Restaurants",
      "poi_address": "1198 SW 27th Ave, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-cbdc-77af-8b0a-7184e3488328.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-cbdc-77af-8b0a-7184e3488328",
        "storage_key": "property/6767906449167741/01a03e5b-cbdc-77af-8b0a-7184e3488328.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://gastrobarlatino.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1485238645440820285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "restaurante-gastrobar-latino",
      "poi_latitude": "26.1069972",
      "poi_longitude": "-80.1774366",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 954-584-7966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN02BJbQB2YgRPbQuzK2gnBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "colombian_restaurant"
    },
    {
      "id": "ec_34d0bdbe6c76758c9250a9dc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "2630 W Broward Blvd Unit 301, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-c8c9-74bd-8a89-e61354ac0008.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-c8c9-74bd-8a89-e61354ac0008",
        "storage_key": "property/6767906449167741/01a03e5b-c8c9-74bd-8a89-e61354ac0008.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/fl/ft-lauderdale/breakfast-2630-w.-broward-blvd-suite-301-360248?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=360248&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=15250451818184019955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "26.1207135",
      "poi_longitude": "-80.1767733",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-656-3648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoavDpRMB2YgR848R1yB9pNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_6f3ac9d26d19906b59c4f693",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "2644 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-cd5c-719d-90f2-d0ace86094a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-cd5c-719d-90f2-d0ace86094a7",
        "storage_key": "property/6767906449167741/01a03e5b-cd5c-719d-90f2-d0ace86094a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pandaexpress.com/locations/fl/fort-lauderdale/3807?utm_source=google_gbp&utm_medium=organic&utm_campaign=websitelink",
      "poi_directions_map_url": "https://maps.google.com/?cid=15708312377418089105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panda-express",
      "poi_latitude": "26.1200695",
      "poi_longitude": "-80.17766139999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-824-9669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wu5A8EB2YgRkYLgjOEi_9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_15c54e7fe897fcdc75131d7b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Sunshine Bakery",
      "poi_type": "Restaurants",
      "poi_address": "2621 Davie Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Modest bakery & eatery showcasing a wide range of pastries, cookies, cakes & Cuban chow.",
      "poi_long_description": "Modest bakery & eatery showcasing a wide range of pastries, cookies, cakes & Cuban chow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-cbd0-7649-b3bd-69ea578aa146.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-cbd0-7649-b3bd-69ea578aa146",
        "storage_key": "property/6767906449167741/01a03e5b-cbd0-7649-b3bd-69ea578aa146.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sunshinebakeryflorida.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5604707829350084204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunshine-bakery",
      "poi_latitude": "26.1070748",
      "poi_longitude": "-80.1764012",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-584-1202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6cis-bcA2YgRbC5DZhPsx00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_67b486ad1fdda5c674917ddb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "El Fogon Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3215 Davie Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Honduran specialties plus other Latin American dishes are served at this casual spot.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-2549-73cf-9b37-e30b804a60bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2549-73cf-9b37-e30b804a60bb",
        "storage_key": "property/6767906449167741/01a03e5c-2549-73cf-9b37-e30b804a60bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://elfogondavie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9600768194693675171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-fogon-restaurant",
      "poi_latitude": "26.1055148",
      "poi_longitude": "-80.1882266",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-283-0975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz06MpTsH2YgRo7iVV87HPIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_447e73594a43fd2bcd0b04cd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "La Aurora Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3023 Davie Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Salvadoran hole-in-the-wall eatery for pupusas and other authentic dishes, plus soups.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-e54b-71fe-8d21-fd6685dd9fc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e54b-71fe-8d21-fd6685dd9fc7",
        "storage_key": "property/6767906449167741/01a03e5b-e54b-71fe-8d21-fd6685dd9fc7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11865054092981024279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-aurora-restaurant",
      "poi_latitude": "26.1059863",
      "poi_longitude": "-80.1853706",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-584-3933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ff1DrUA2YgRF7btdNUjqaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_31b5a6c0be28c00ec1b46848",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Popular chain selling groceries, household items, baby gear, furniture, clothing and electronics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-ed6f-762b-a071-8860e10dadeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-ed6f-762b-a071-8860e10dadeb",
        "storage_key": "property/6767906449167741/01a03e5b-ed6f-762b-a071-8860e10dadeb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/2946-fort-lauderdale-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16622688920120171414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "26.119425",
      "poi_longitude": "-80.1752605",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-453-6538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-881b-7076-b59b-44d35b91de29",
        "storage_key": "property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVf3uYOQA2YgRlpuVh4Cnr-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_a9682be9ddcc14fe1dde942f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Publix Super Market at West Broward Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3901 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-ec43-7148-a16c-c7ba1bab9c5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-ec43-7148-a16c-c7ba1bab9c5c",
        "storage_key": "property/6767906449167741/01a03e5b-ec43-7148-a16c-c7ba1bab9c5c.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_content=psm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=5098617142493238879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-west-broward-shopping-center",
      "poi_latitude": "26.1226507",
      "poi_longitude": "-80.2010031",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 954-331-1457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b1a-702e-a7c4-58099bc8ad14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b1a-702e-a7c4-58099bc8ad14",
        "storage_key": "property/6767906449167741/01a03e5a-8b1a-702e-a7c4-58099bc8ad14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj0EclSkH2YgRX9YGCEftwUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_8edcc28902877c84abe8a2ed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3501 W, 3501 Davie Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-e2f1-7749-9e95-7c8f033af1e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e2f1-7749-9e95-7c8f033af1e3",
        "storage_key": "property/6767906449167741/01a03e5b-e2f1-7749-9e95-7c8f033af1e3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/fort-lauderdale-fl-pharmacies/3501-w-davie-blvd-fort-lauderdale-fl-33312/storeid=981?WT.mc_id=LS_GOOGLE_RX_981",
      "poi_directions_map_url": "https://maps.google.com/?cid=17708080144292784286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "26.105005",
      "poi_longitude": "-80.193747",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-583-9195",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-aedf-732b-a303-d151752a55d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-aedf-732b-a303-d151752a55d3",
        "storage_key": "property/6767906449167741/01a03e5c-aedf-732b-a303-d151752a55d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwwTjeUkH2YgRnii43hG9v_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_f9bfb3b01ffa3bf2c707bd7f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "3895 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-e5fa-718a-85e4-83b86e7e6e5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e5fa-718a-85e4-83b86e7e6e5a",
        "storage_key": "property/6767906449167741/01a03e5b-e5fa-718a-85e4-83b86e7e6e5a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3895+w+broward+blvd-ft+lauderdale-fl-33312/id=4569",
      "poi_directions_map_url": "https://maps.google.com/?cid=18202970179442047581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "26.1216573",
      "poi_longitude": "-80.20046479999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 954-316-6641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2ciRiUH2YgRXfqrSu_wnfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_1a90acebab60e4e77c3a730d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "2990 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-f594-73ab-8132-b337b91a4a49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f594-73ab-8132-b337b91a4a49",
        "storage_key": "property/6767906449167741/01a03e5b-f594-73ab-8132-b337b91a4a49.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/fl/fort-lauderdale/2990-w-broward-blvd-37288?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14942937684212017828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "26.1209462",
      "poi_longitude": "-80.1844082",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 954-587-8132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-aee0-74ef-ac0e-ea5897d79b55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-aee0-74ef-ac0e-ea5897d79b55",
        "storage_key": "property/6767906449167741/01a03e5c-aee0-74ef-ac0e-ea5897d79b55.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJXzh9XtIA2YgRpGpBGKf6X88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_18615197d2faece5b056ba32",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "3857 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-f417-7269-ba45-1b95aa313707.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f417-7269-ba45-1b95aa313707",
        "storage_key": "property/6767906449167741/01a03e5b-f417-7269-ba45-1b95aa313707.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dollartree.com/fl/fort-lauderdale/3857-west-broward-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2404321954700409168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "26.122308",
      "poi_longitude": "-80.2000375",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 754-206-7549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-881b-7076-b59b-44d35b91de29",
        "storage_key": "property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAZ2KWiUH2YgRUDmXQxTeXSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_0df39e6cb451875da11204b8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "2660 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-fa61-7105-840a-333ab0440e41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-fa61-7105-840a-333ab0440e41",
        "storage_key": "property/6767906449167741/01a03e5b-fa61-7105-840a-333ab0440e41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14066589212067708262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "26.1192896",
      "poi_longitude": "-80.1771547",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-797-8719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-881b-7076-b59b-44d35b91de29",
        "storage_key": "property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJq5TRsoMB2YgRZj2jQlyQNsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_5daed29a07561e674b06ad0b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Five Below",
      "poi_type": "Shopping & Retail",
      "poi_address": "2660 W Broward Blvd Suite 106, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_long_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-f9dd-712c-8469-9a3f9e8798ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f9dd-712c-8469-9a3f9e8798ef",
        "storage_key": "property/6767906449167741/01a03e5b-f9dd-712c-8469-9a3f9e8798ef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.fivebelow.com/fl/ft-lauderdale/2660-w-broward-boulevard?utm_source=gmb&utm_medium=yext&y_source=1_MTM1MzkxNDAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298130485983091746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-below",
      "poi_latitude": "26.1191921",
      "poi_longitude": "-80.1764438",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-797-2047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-881b-7076-b59b-44d35b91de29",
        "storage_key": "property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6_vUbHwB2YgRIpyEQICZ5B8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_3552002ca6cf0469dfc1f9fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Wawa",
      "poi_type": "Restaurants",
      "poi_address": "2620 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5b-f46d-72ed-b914-3e310039009f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f46d-72ed-b914-3e310039009f",
        "storage_key": "property/6767906449167741/01a03e5b-f46d-72ed-b914-3e310039009f.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/5232?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=16686033403819513991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "26.121162",
      "poi_longitude": "-80.177536",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-652-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8814-71be-8f00-c112da8f1972",
        "storage_key": "property/6767906449167741/01a03e5a-8814-71be-8f00-c112da8f1972.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM7qNXdAA2YgRh9j2cPmykOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_aeada4b537e2dd59c503f7a3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Jack & Jill Center",
      "poi_type": "Education",
      "poi_address": "Halmos Family Building, 1315 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-092d-714a-804c-0dedaadd49b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-092d-714a-804c-0dedaadd49b4",
        "storage_key": "property/6767906449167741/01a03e5c-092d-714a-804c-0dedaadd49b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jackandjillcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5051683243341354166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack--jill-center",
      "poi_latitude": "26.1221886",
      "poi_longitude": "-80.159222",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 954-463-8772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOcBaFuQA2YgRtpQnFSUvG0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_37359f6ce786aee3870c1d42",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Future Genius Academy",
      "poi_type": "Education",
      "poi_address": "3001 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-0989-778a-95e9-066be9fcc72d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0989-778a-95e9-066be9fcc72d",
        "storage_key": "property/6767906449167741/01a03e5c-0989-778a-95e9-066be9fcc72d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.futuregeniusacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14615590590773825691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "future-genius-academy",
      "poi_latitude": "26.1215261",
      "poi_longitude": "-80.18446829999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 754-301-2765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJScYg9y4H2YgRm5CdoTQC1co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_ad4db966e4e4c80d9d9dc057",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Westwood Heights Elementary School",
      "poi_type": "Education",
      "poi_address": "2861 SW 9th St, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-0757-7238-b77e-749d39098736.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0757-7238-b77e-749d39098736",
        "storage_key": "property/6767906449167741/01a03e5c-0757-7238-b77e-749d39098736.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.browardschools.com/westwoodheights",
      "poi_directions_map_url": "https://maps.google.com/?cid=14101827974284748175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-heights-elementary-school",
      "poi_latitude": "26.111269",
      "poi_longitude": "-80.1825379",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 754-323-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_Z7C2ssA2YgRj6Xo8tPBs8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_434045515861c9133b53263c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Riverland Elementary School",
      "poi_type": "Education",
      "poi_address": "2600 SW 11th Ct, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6318252994629116764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverland-elementary-school",
      "poi_latitude": "26.1089258",
      "poi_longitude": "-80.1759694",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 754-323-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-Y1r5McA2YgRXKPqgZ_xrlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_cdb8ea1af939777e28c2053e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "New River Middle School",
      "poi_type": "Education",
      "poi_address": "3100 Riverland Rd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-099b-76b8-ad60-89ab79e368f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-099b-76b8-ad60-89ab79e368f4",
        "storage_key": "property/6767906449167741/01a03e5c-099b-76b8-ad60-89ab79e368f4.webp",
        "width": 1022,
        "height": 515
      },
      "poi_business_url": "https://newriver.browardschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11040184662445011387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-river-middle-school",
      "poi_latitude": "26.0904772",
      "poi_longitude": "-80.1863264",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 754-323-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx4RdXqsA2YgRuzHAA3WdNpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_5cfbd7c2a587525408d71f62",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Stephen Foster Elementary School",
      "poi_type": "Education",
      "poi_address": "3471 SW 22nd St, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-1031-71f6-9c55-256ebdd2599b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1031-71f6-9c55-256ebdd2599b",
        "storage_key": "property/6767906449167741/01a03e5c-1031-71f6-9c55-256ebdd2599b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stephenfoster.browardschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3611199121714794654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stephen-foster-elementary-school",
      "poi_latitude": "26.095485",
      "poi_longitude": "-80.191926",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 754-323-5750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnT-xE1IH2YgRnlAD33eOHTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_932237bbb323b36ac34454d0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Parkway Middle School",
      "poi_type": "Education",
      "poi_address": "3600 NW 5th Ct, Fort Lauderdale, FL 33311, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-0be3-7121-99e2-cfdccaa224cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0be3-7121-99e2-cfdccaa224cb",
        "storage_key": "property/6767906449167741/01a03e5c-0be3-7121-99e2-cfdccaa224cb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.browardschools.com/parkway",
      "poi_directions_map_url": "https://maps.google.com/?cid=8088277251353395433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkway-middle-school",
      "poi_latitude": "26.1266962",
      "poi_longitude": "-80.1962396",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 754-322-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvQ15KikH2YgR6cDKe05VP3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_bc74eb7b2f48b37e93d45a86",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Broward Children's Center",
      "poi_type": "Education",
      "poi_address": "3891 Stirling Rd, Dania Beach, FL 33060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-186c-73b8-916d-1e24ee9a7942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-186c-73b8-916d-1e24ee9a7942",
        "storage_key": "property/6767906449167741/01a03e5c-186c-73b8-916d-1e24ee9a7942.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://bcckids.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7002595224267171778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-childrens-center",
      "poi_latitude": "26.0475394",
      "poi_longitude": "-80.1992404",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 954-416-2444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-eEoSkWq2YgRwqdKUEE3LmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_49f1bc892ed84ef9b332ac18",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "South Plantation High School",
      "poi_type": "Education",
      "poi_address": "1300 SW 54th Ave, Plantation, FL 33317, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-1f7d-7198-b52b-7cb279e45c58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1f7d-7198-b52b-7cb279e45c58",
        "storage_key": "property/6767906449167741/01a03e5c-1f7d-7198-b52b-7cb279e45c58.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.browardschools.com/southplantation",
      "poi_directions_map_url": "https://maps.google.com/?cid=8745619948133503973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-plantation-high-school",
      "poi_latitude": "26.1031125",
      "poi_longitude": "-80.2201875",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 754-323-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1wcoDG4H2YgR5VMRrQGvXnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_146b4c7c887cb68effee3fdf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Broward College - A. Hugh Adams Central Campus",
      "poi_type": "Education",
      "poi_address": "3501 Davie Rd, Davie, FL 33314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-2b96-7345-ae83-6754898b2b58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-2b96-7345-ae83-6754898b2b58",
        "storage_key": "property/6767906449167741/01a03e59-2b96-7345-ae83-6754898b2b58.webp",
        "width": 1256,
        "height": 1280
      },
      "poi_business_url": "http://www.broward.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3552845722620468708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-college---a-hugh-adams-central-campus",
      "poi_latitude": "26.0799557",
      "poi_longitude": "-80.2357037",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 954-201-7350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmb9-5Cyo2YgR5B2PZlw-TjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_442aa2d1720df1f3d67f1d87",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Regal Broward",
      "poi_type": "Entertainment",
      "poi_address": "8000 W Broward Blvd #1840, Plantation, FL 33388, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-2808-733a-add9-bd77969fdc44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2808-733a-add9-bd77969fdc44",
        "storage_key": "property/6767906449167741/01a03e5c-2808-733a-add9-bd77969fdc44.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-broward-rpx-1762?utm_campaign=gmb-listing&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=7463737642510168395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-broward",
      "poi_latitude": "26.1161844",
      "poi_longitude": "-80.2539123",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-aedf-732b-a303-d64c7c92dd56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-aedf-732b-a303-d64c7c92dd56",
        "storage_key": "property/6767906449167741/01a03e5c-aedf-732b-a303-d64c7c92dd56.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSZkY8cH2YgRS7GHXteFlGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_33e376ffa76d47506b475f5d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Plantation Walk",
      "poi_type": "Shopping & Retail",
      "poi_address": "321 N University Dr, Plantation, FL 33322, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-2873-702b-99fa-10c73d0d2dd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2873-702b-99fa-10c73d0d2dd6",
        "storage_key": "property/6767906449167741/01a03e5c-2873-702b-99fa-10c73d0d2dd6.webp",
        "width": 1280,
        "height": 604
      },
      "poi_business_url": "https://plantationwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12649695790913343402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plantation-walk",
      "poi_latitude": "26.1252972",
      "poi_longitude": "-80.2562619",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-308-0515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-881b-7076-b59b-44d35b91de29",
        "storage_key": "property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHZo538oH2YgRqs8kBk2_jK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_1e3caad8e0b78bc1fa0b3aa4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Fort Lauderdale Swap Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "3291 W Sunrise Blvd, Fort Lauderdale, FL 33311, USA",
      "poi_short_description": "Sprawling 1960s facility with a flea market, a Ferrari museum & a 14-screen drive-in movie theater.",
      "poi_long_description": "Sprawling 1960s facility with a flea market, a Ferrari museum & a 14-screen drive-in movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-2b37-7573-89ae-b12a80979cfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2b37-7573-89ae-b12a80979cfd",
        "storage_key": "property/6767906449167741/01a03e5c-2b37-7573-89ae-b12a80979cfd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://floridaswapshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2934117349858609916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-swap-shop",
      "poi_latitude": "26.1370252",
      "poi_longitude": "-80.1910838",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-791-7927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-881b-7076-b59b-44d35b91de29",
        "storage_key": "property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJazjmCdQG2YgR_AqiHy8UuCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "flea_market"
    },
    {
      "id": "ec_2248cda4a0c0db78fdb384cc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Museum of Discovery and Science",
      "poi_type": "Entertainment",
      "poi_address": "401 SW 2nd St, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Downtown facility offering interactive exhibits for kids & adults, eco-center & giant IMAX theater.",
      "poi_long_description": "Downtown facility offering interactive exhibits for kids & adults, eco-center & giant IMAX theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-24ba-778b-b0af-69aa81e1dd82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-24ba-778b-b0af-69aa81e1dd82",
        "storage_key": "property/6767906449167741/01a03e59-24ba-778b-b0af-69aa81e1dd82.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mods.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3792408130309737923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-discovery-and-science",
      "poi_latitude": "26.1206046",
      "poi_longitude": "-80.1479671",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-467-6637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8806-728b-8157-bce6de95f3df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8806-728b-8157-bce6de95f3df",
        "storage_key": "property/6767906449167741/01a03e5a-8806-728b-8157-bce6de95f3df.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2f1pZPkA2YgRw01q-hlXoTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_ebeb120cb00c6e3cd7de41a7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "NSU Art Museum Fort Lauderdale",
      "poi_type": "Entertainment",
      "poi_address": "1 E Las Olas Blvd, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "Complex with more than 6,000 works of art, plus an academy, bookstore & cafe.",
      "poi_long_description": "Complex with more than 6,000 works of art, plus an academy, bookstore & cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-330a-7540-b880-0be28cf9843c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-330a-7540-b880-0be28cf9843c",
        "storage_key": "property/6767906449167741/01a03e5c-330a-7540-b880-0be28cf9843c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://nsuartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10636868273401707191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nsu-art-museum-fort-lauderdale",
      "poi_latitude": "26.1196496",
      "poi_longitude": "-80.14276869999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 954-525-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8806-728b-8157-bce6de95f3df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8806-728b-8157-bce6de95f3df",
        "storage_key": "property/6767906449167741/01a03e5a-8806-728b-8157-bce6de95f3df.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJdR_OXS4A2YgRtzq7jla_nZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_13183175c778cbb633d44656",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Revolution Live",
      "poi_type": "Entertainment",
      "poi_address": "100 SW 3rd Ave, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Sprawling venue for live electronic, rock, funk & more on indoor & outdoor stages, plus VIP areas.",
      "poi_long_description": "Sprawling venue for live electronic, rock, funk & more on indoor & outdoor stages, plus VIP areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-24d7-715f-8fa5-21a17f74c25d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-24d7-715f-8fa5-21a17f74c25d",
        "storage_key": "property/6767906449167741/01a03e5c-24d7-715f-8fa5-21a17f74c25d.webp",
        "width": 1280,
        "height": 526
      },
      "poi_business_url": "http://www.jointherevolution.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8958436674005782080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "revolution-live",
      "poi_latitude": "26.121358",
      "poi_longitude": "-80.14619739999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-449-1025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_a4nLvkA2YgRQE7y8LDCUnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_a0beaced248297ef8984ca1e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Broward Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "201 SW 5th Ave, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Renovated theater hosting musicals, comedies, speakers & more, with luxe new Club Level lounge.",
      "poi_long_description": "Renovated theater hosting musicals, comedies, speakers & more, with luxe new Club Level lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-7f7f-7637-a5f0-ec2d99ecfffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7f7f-7637-a5f0-ec2d99ecfffe",
        "storage_key": "property/6767906449167741/01a03e5c-7f7f-7637-a5f0-ec2d99ecfffe.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.browardcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2531387348230524317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-center-for-the-performing-arts",
      "poi_latitude": "26.1197559",
      "poi_longitude": "-80.14957729999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-462-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs8G0zPsA2YgRnc0yoGFLISM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_ebb7f47bfc302b92af464f42",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "The Parker",
      "poi_type": "Entertainment",
      "poi_address": "707 NE 8th St, Fort Lauderdale, FL 33304, USA",
      "poi_short_description": "Since 1967, this 1,167-seat theater has hosted Broadway plays, live music, dance, comedy & more.",
      "poi_long_description": "Since 1967, this 1,167-seat theater has hosted Broadway plays, live music, dance, comedy & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-321d-75ab-b945-215762bbc34c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-321d-75ab-b945-215762bbc34c",
        "storage_key": "property/6767906449167741/01a03e5c-321d-75ab-b945-215762bbc34c.webp",
        "width": 719,
        "height": 632
      },
      "poi_business_url": "http://parkerplayhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2557896587494693529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-parker",
      "poi_latitude": "26.134333",
      "poi_longitude": "-80.1362059",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 954-462-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmY1Oo64B2YgRmRrO3WR5fyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_6f737c4009494db0879571ad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Bonnet House Museum & Gardens",
      "poi_type": "Entertainment",
      "poi_address": "900 N Birch Rd, Fort Lauderdale, FL 33304, USA",
      "poi_short_description": "Verdant, storied, 1920s-era plantation home featuring gardens, an arty interior, tours & more.",
      "poi_long_description": "Verdant, storied, 1920s-era plantation home featuring gardens, an arty interior, tours & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-2a25-73ee-a296-119ad39d7b3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-2a25-73ee-a296-119ad39d7b3f",
        "storage_key": "property/6767906449167741/01a03e59-2a25-73ee-a296-119ad39d7b3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bonnethouse.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10089391772052130854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonnet-house-museum--gardens",
      "poi_latitude": "26.1363719",
      "poi_longitude": "-80.1069179",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 954-563-5393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8806-728b-8157-bce6de95f3df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8806-728b-8157-bce6de95f3df",
        "storage_key": "property/6767906449167741/01a03e5a-8806-728b-8157-bce6de95f3df.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOzaIz9AB2YgRJozqXFy4BIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_bda01482ee377832d96fab46",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Jungle Queen Riverboat",
      "poi_type": "Entertainment",
      "poi_address": "801 Seabreeze Blvd, Fort Lauderdale, FL 33316, USA",
      "poi_short_description": "Vintage riverboat offering sightseeing tours of Fort Lauderdale waterways, dinner & show cruises.",
      "poi_long_description": "Vintage riverboat offering sightseeing tours of Fort Lauderdale waterways, dinner & show cruises.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-3b7c-760a-8ecb-0ecdc9c1a840.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-3b7c-760a-8ecb-0ecdc9c1a840",
        "storage_key": "property/6767906449167741/01a03e5c-3b7c-760a-8ecb-0ecdc9c1a840.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.junglequeen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15186341205432802937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jungle-queen-riverboat",
      "poi_latitude": "26.1113305",
      "poi_longitude": "-80.105976",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 954-462-5596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq81qhSUA2YgReR6zm924wNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_894cfc56763a8c5199e3131b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "HCA Florida Westside Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "8201 W Broward Blvd, Plantation, FL 33324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-3adc-72aa-81e0-2065b23014ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-3adc-72aa-81e0-2065b23014ec",
        "storage_key": "property/6767906449167741/01a03e59-3adc-72aa-81e0-2065b23014ec.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.hcafloridahealthcare.com/locations/westside-hospital/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9020797386572349422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-florida-westside-hospital",
      "poi_latitude": "26.123542",
      "poi_longitude": "-80.259512",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-473-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-880e-7143-845c-40bc077fd630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-880e-7143-845c-40bc077fd630",
        "storage_key": "property/6767906449167741/01a03e5a-880e-7143-845c-40bc077fd630.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zEED8YH2YgR7r9qyW1PMH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_1ca32dc7209b41a1afd09514",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Broward Health Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 S Andrews Ave, Fort Lauderdale, FL 33316, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-35c2-76ba-8a62-0891784f7131.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-35c2-76ba-8a62-0891784f7131",
        "storage_key": "property/6767906449167741/01a03e59-35c2-76ba-8a62-0891784f7131.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.browardhealth.org/locations/broward-health-medical-center?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13938975603465299802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-health-medical-center",
      "poi_latitude": "26.1020681",
      "poi_longitude": "-80.1408664",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 954-355-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-880e-7143-845c-40bc077fd630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-880e-7143-845c-40bc077fd630",
        "storage_key": "property/6767906449167741/01a03e5a-880e-7143-845c-40bc077fd630.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUw_UmAA2YgRWqdioXUwccE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_9daea686f015899805817ddc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Plantation Urgent Care Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3800 W Broward Blvd Ste 101, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-4ad5-770c-87bd-c0fef3d9a0e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4ad5-770c-87bd-c0fef3d9a0e1",
        "storage_key": "property/6767906449167741/01a03e5c-4ad5-770c-87bd-c0fef3d9a0e1.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "https://www.urgentcareplantation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5321483691703783472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plantation-urgent-care-center",
      "poi_latitude": "26.1206333",
      "poi_longitude": "-80.1997981",
      "poi_miles_from_property": "358 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 954-237-2793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_yAhwz0H2YgRMNAJIjm12Uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e3fc77d290f054526602e1dc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Urgent Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6931 W Broward Blvd, Plantation, FL 33317, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-40f9-710e-9807-5045ae2702cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-40f9-710e-9807-5045ae2702cc",
        "storage_key": "property/6767906449167741/01a03e5c-40f9-710e-9807-5045ae2702cc.webp",
        "width": 373,
        "height": 497
      },
      "poi_business_url": "https://www.urgentcarefl.com/locations/plantation-fl/?utm_source=google&utm_medium=organic&utm_campaign=gmb-page-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10995145950450993208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urgent-medical-center",
      "poi_latitude": "26.1220727",
      "poi_longitude": "-80.239869",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-321-5191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNwI-uqUH2YgROMg0tvyalpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_8585b8a5c7254c16427ada41",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-436b-70fd-a859-14f76eafb8e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-436b-70fd-a859-14f76eafb8e0",
        "storage_key": "property/6767906449167741/01a03e5c-436b-70fd-a859-14f76eafb8e0.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/2946-fort-lauderdale-fl/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=261251569990556427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "26.1195155",
      "poi_longitude": "-80.1753188",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-453-6537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-aedf-732b-a303-d151752a55d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-aedf-732b-a303-d151752a55d3",
        "storage_key": "property/6767906449167741/01a03e5c-aedf-732b-a303-d151752a55d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_qlitoA2YgRC9tMMusmoAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_8484e4d5f8807ed011e453dd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2670 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Clean establishment providing treadmills and tanning beds, along with hydro massage chairs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-2eaf-75b9-9a5b-46353cb9a719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-2eaf-75b9-9a5b-46353cb9a719",
        "storage_key": "property/6767906449167741/01a03e59-2eaf-75b9-9a5b-46353cb9a719.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/fort-lauderdale-w-broward-blvd-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16792247515653916999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "26.1191269",
      "poi_longitude": "-80.17760009999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-587-5887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWyDfY9AA2YgRR8n8diUMCuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f6abbbc131608fe28d4d23a5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Sacred Form Yoga Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "5223 W Broward Blvd, Plantation, FL 33317, USA",
      "poi_short_description": "Calm and welcoming yoga studio offering traditional classes such as Vinyasa and Hatha, plus Pilates and Tai Chi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-5df7-7333-b53e-0e111c40c0e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5df7-7333-b53e-0e111c40c0e5",
        "storage_key": "property/6767906449167741/01a03e5c-5df7-7333-b53e-0e111c40c0e5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sacredform.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8443857176570927580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sacred-form-yoga-studio",
      "poi_latitude": "26.1217767",
      "poi_longitude": "-80.2187209",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 954-980-4827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxX5DP5MH2YgR3JmkV12bLnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_137ea79c6569a937cb838953",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Plantation Preserve Golf Course & Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7050 W Broward Blvd, Plantation, FL 33317, USA",
      "poi_short_description": "Golf course with Paspalum grass fairways and rolling hills, plus a clubhouse with a restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-51ef-72e2-977c-e494fde1cfb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-51ef-72e2-977c-e494fde1cfb8",
        "storage_key": "property/6767906449167741/01a03e5c-51ef-72e2-977c-e494fde1cfb8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.plantation.org/government/departments/parks-recreation/plantation-preserve-golf-course-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=7952140005920366799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plantation-preserve-golf-course--club",
      "poi_latitude": "26.1187603",
      "poi_longitude": "-80.2423738",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-585-5020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-aeef-76dd-8536-2757783eb152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-aeef-76dd-8536-2757783eb152",
        "storage_key": "property/6767906449167741/01a03e5c-aeef-76dd-8536-2757783eb152.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJL45sv6QH2YgRz2AOATStW24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_0db031b9c2a13443de021da6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Happy Tails Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6600 SW 16th St, Plantation, FL 33317, USA",
      "poi_short_description": "Popular outdoor park featuring 3+ areas for dogs of all sizes, plus agility equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-5ba3-73f8-96c4-8682cfa8f330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5ba3-73f8-96c4-8682cfa8f330",
        "storage_key": "property/6767906449167741/01a03e5c-5ba3-73f8-96c4-8682cfa8f330.webp",
        "width": 1280,
        "height": 1245
      },
      "poi_business_url": "https://www.plantation.org/Home/Components/FacilityDirectory/FacilityDirectory/20/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16917250168838546698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-tails-dog-park",
      "poi_latitude": "26.1018999",
      "poi_longitude": "-80.2347724",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-797-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d29-776e-8cbc-b6502cc92752",
        "storage_key": "property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvX9wWZwH2YgRCuUJqmUlxuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_7820bc6f8980de6f993b1ffe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Plantation Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 S Fig Tree Ln, Plantation, FL 33317, USA",
      "poi_short_description": "Longtime park with a lake & features such as a fitness trail, disc golf course & 2 playgrounds.",
      "poi_long_description": "Longtime park with a lake & features such as a fitness trail, disc golf course & 2 playgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-5ecc-75b6-8006-b1cb81802215.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5ecc-75b6-8006-b1cb81802215",
        "storage_key": "property/6767906449167741/01a03e5c-5ecc-75b6-8006-b1cb81802215.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.broward.org/Parks/Pages/Park.aspx?=27",
      "poi_directions_map_url": "https://maps.google.com/?cid=11584781081341918790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plantation-heritage-park",
      "poi_latitude": "26.1067755",
      "poi_longitude": "-80.2309083",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 954-357-5135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d29-776e-8cbc-b6502cc92752",
        "storage_key": "property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0R0ZKp4H2YgRRv4MwgNpxaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8592245db41c6d6543388f99",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Plantation Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "511 N Fig Tree Ln, Plantation, FL 33317, USA",
      "poi_short_description": "Quaint museum offering permanent exhibits on regional history, a gift shop & a butterfly garden.",
      "poi_long_description": "Quaint museum offering permanent exhibits on regional history, a gift shop & a butterfly garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-5a10-76de-896a-71b911e1bbae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5a10-76de-896a-71b911e1bbae",
        "storage_key": "property/6767906449167741/01a03e5c-5a10-76de-896a-71b911e1bbae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://plantationhistoricalsociety.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8626916131252712764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plantation-historical-museum",
      "poi_latitude": "26.128799",
      "poi_longitude": "-80.2300262",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-797-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8806-728b-8157-bce6de95f3df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8806-728b-8157-bce6de95f3df",
        "storage_key": "property/6767906449167741/01a03e5a-8806-728b-8157-bce6de95f3df.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVLHSwEH2YgRPLVnloP2uHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_a094ccd7df86645106e2e772",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Volunteer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12050 W Sunrise Blvd, Plantation, FL 33324, USA",
      "poi_short_description": "Recreational trails along wetlands and a children's play area, plus picnic spaces.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-680a-7131-aa5f-5443c00d2d49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-680a-7131-aa5f-5443c00d2d49",
        "storage_key": "property/6767906449167741/01a03e5c-680a-7131-aa5f-5443c00d2d49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.plantation.org/Home/Components/FacilityDirectory/FacilityDirectory/42/292",
      "poi_directions_map_url": "https://maps.google.com/?cid=3623881429341404572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "volunteer-park",
      "poi_latitude": "26.1456265",
      "poi_longitude": "-80.3079792",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 954-452-2558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d29-776e-8cbc-b6502cc92752",
        "storage_key": "property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-v6_vYI2YgRnH0HuPWcSjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ea7a13b784fe972be8679edd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Pine Island Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "320 S Pine Island Rd, Plantation, FL 33324, USA",
      "poi_short_description": "Public park offering soccer and football fields, as well as picnic areas and a restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-6daf-742b-9b69-890de86184cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-6daf-742b-9b69-890de86184cd",
        "storage_key": "property/6767906449167741/01a03e5c-6daf-742b-9b69-890de86184cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.plantation.org/Home/Components/FacilityDirectory/FacilityDirectory/26/285",
      "poi_directions_map_url": "https://maps.google.com/?cid=1856583920682302149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pine-island-park",
      "poi_latitude": "26.1152854",
      "poi_longitude": "-80.2599103",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 954-452-2510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d29-776e-8cbc-b6502cc92752",
        "storage_key": "property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxiTJMIH2YgRxXr4Pz3pwxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9bf27aa8cb7d530b8da293fe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Pop Travers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6250 SW 16th St, Plantation, FL 33317, USA",
      "poi_short_description": "Park offering softball fields, a concession stand & restrooms, plus a playground & picnic pavilions.",
      "poi_long_description": "Park offering softball fields, a concession stand & restrooms, plus a playground & picnic pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-855c-722b-81b0-9bcc4c65e1e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-855c-722b-81b0-9bcc4c65e1e2",
        "storage_key": "property/6767906449167741/01a03e5c-855c-722b-81b0-9bcc4c65e1e2.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.plantation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3182949327776152090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pop-travers-park",
      "poi_latitude": "26.0996822",
      "poi_longitude": "-80.2331229",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-452-2510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d29-776e-8cbc-b6502cc92752",
        "storage_key": "property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdVa4Tp0H2YgRGnoqtIwbLCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d83bda432b665bc64b781b33",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Plantation Woods",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5555 Palm Tree Rd, Plantation, FL 33317, USA",
      "poi_short_description": "Whimsical 2.5-acre park with multiple woodland-themed play areas, art & a splash pad.",
      "poi_long_description": "Whimsical 2.5-acre park with multiple woodland-themed play areas, art & a splash pad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-6ff4-7365-a59f-31dd22b40fec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-6ff4-7365-a59f-31dd22b40fec",
        "storage_key": "property/6767906449167741/01a03e5c-6ff4-7365-a59f-31dd22b40fec.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.plantation.org/Home/Components/FacilityDirectory/FacilityDirectory/28/285?npage=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9615593872024475709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plantation-woods",
      "poi_latitude": "26.1285133",
      "poi_longitude": "-80.2244676",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-797-2180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d29-776e-8cbc-b6502cc92752",
        "storage_key": "property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWuKjwMH2YgRPRhxVq5zcYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_29faaf420f69015ef3b55a2d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "East Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "699 NW 47th Ave, Plantation, FL 33317, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-85c6-707a-bfba-a45b7bc528e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-85c6-707a-bfba-a45b7bc528e7",
        "storage_key": "property/6767906449167741/01a03e5c-85c6-707a-bfba-a45b7bc528e7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12314106505495125775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-lake-park",
      "poi_latitude": "26.130715",
      "poi_longitude": "-80.212689",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-797-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d29-776e-8cbc-b6502cc92752",
        "storage_key": "property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2zaiUh4H2YgRDx9dsp9-5Ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_621cdd91003c6d20fc56cfc0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Plantation Park East (Kingsley Park)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4680 NW 9th Ct, Plantation, FL 33317, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-7d2f-7384-a19d-ca8029a81158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7d2f-7384-a19d-ca8029a81158",
        "storage_key": "property/6767906449167741/01a03e5c-7d2f-7384-a19d-ca8029a81158.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720445109832384656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plantation-park-east-kingsley-park",
      "poi_latitude": "26.1349909",
      "poi_longitude": "-80.21228909999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d29-776e-8cbc-b6502cc92752",
        "storage_key": "property/6767906449167741/01a03e5a-8d29-776e-8cbc-b6502cc92752.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxPcTeAG2YgRkAAG1bpip6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6d3e6831c239d5214a82321c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Fort Lauderdale",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 SW 21st Terrace, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-52ff-716d-a8e8-223b9e1cebbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-52ff-716d-a8e8-223b9e1cebbc",
        "storage_key": "property/6767906449167741/01a03e59-52ff-716d-a8e8-223b9e1cebbc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=FTL",
      "poi_directions_map_url": "https://maps.google.com/?cid=17672924595077936610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale",
      "poi_latitude": "26.1192659",
      "poi_longitude": "-80.1700018",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-980c-74cb-a382-2bd79e052b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-980c-74cb-a382-2bd79e052b8e",
        "storage_key": "property/6767906449167741/01a03e5a-980c-74cb-a382-2bd79e052b8e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6XrWsMA2YgR4nXit0jXQvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_65d3d2185f424fc48e9fc88a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Broward County Transit (Central Terminal)",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 NW 1st Ave, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-8da4-7478-8ed2-6ff7e4375f03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8da4-7478-8ed2-6ff7e4375f03",
        "storage_key": "property/6767906449167741/01a03e5c-8da4-7478-8ed2-6ff7e4375f03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.broward.org/BCT/Riders/Pages/JustTryIt.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=408228831615665290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-county-transit-central-terminal",
      "poi_latitude": "26.1232797",
      "poi_longitude": "-80.145039",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 954-357-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52vyvv8B2YgRikSGn_VRqgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_a0e6352da23d666389e8c600",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Greyhound",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 NW 22nd Ave, Fort Lauderdale, FL 33311, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-8f2a-733a-b9d1-2bc642fce72c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8f2a-733a-b9d1-2bc642fce72c",
        "storage_key": "property/6767906449167741/01a03e5c-8f2a-733a-b9d1-2bc642fce72c.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/fort-lauderdale-fl/ft-lauderdale-broward-park-ride?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=10878784953966330820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound",
      "poi_latitude": "26.1244118",
      "poi_longitude": "-80.1707742",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqWetj1QA2YgRxAMHAUc1-ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_49b9029fd38a945468d16bc5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Fort Lauderdale-Hollywood International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 Terminal Dr, Fort Lauderdale, FL 33315, USA",
      "poi_short_description": "Airport with free WiFi, a cell phone waiting lot & areas to observe planes taking off & landing.",
      "poi_long_description": "Airport with free WiFi, a cell phone waiting lot & areas to observe planes taking off & landing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-95bc-72c9-950b-f02dfb050e0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-95bc-72c9-950b-f02dfb050e0f",
        "storage_key": "property/6767906449167741/01a03e5c-95bc-72c9-950b-f02dfb050e0f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.broward.org/airport/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3089526096205892582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-hollywood-international-airport",
      "poi_latitude": "26.0731729",
      "poi_longitude": "-80.1512317",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 866-435-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-9747-72d4-9014-6dc27ff9f008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9747-72d4-9014-6dc27ff9f008",
        "storage_key": "property/6767906449167741/01a03e5a-9747-72d4-9014-6dc27ff9f008.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9frI5Hqq2YgR5sumkJ0z4Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_a48cb983f0ea49e8c892d7a3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Fort Lauderdale Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 Gulf Stream Way, Dania Beach, FL 33004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-6115-73d9-be56-01f1cc02ebf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-6115-73d9-be56-01f1cc02ebf2",
        "storage_key": "property/6767906449167741/01a03e59-6115-73d9-be56-01f1cc02ebf2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tri-rail.com/stations/fort-lauderdalehollywood-international-airport-at-dania-beach/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1078809497329506260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-airport",
      "poi_latitude": "26.0616447",
      "poi_longitude": "-80.16561879999999",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-980c-74cb-a382-2bd79e052b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-980c-74cb-a382-2bd79e052b8e",
        "storage_key": "property/6767906449167741/01a03e5a-980c-74cb-a382-2bd79e052b8e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJx53JMRWq2YgR1JekpIWz-A4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_777360fb15c364db15b3d5d5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Port Everglades Administrative Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1850 Eller Dr, Fort Lauderdale, FL 33316, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.porteverglades.net/about-us/port-administration/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9412866544889991288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-everglades-administrative-offices",
      "poi_latitude": "26.0816643",
      "poi_longitude": "-80.12061179999999",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-aefc-72b2-872d-061517eaf9b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-aefc-72b2-872d-061517eaf9b1",
        "storage_key": "property/6767906449167741/01a03e5c-aefc-72b2-872d-061517eaf9b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ySOHtAB2YgReJBTRkA4oYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_a53342bc06d30fe45b3be36a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Cypress Creek",
      "poi_type": "Transportation & Transit",
      "poi_address": "5910 NW 9th Avenue, Fort Lauderdale, FL 33309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-9237-7083-9e00-b5d8cccfbed0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9237-7083-9e00-b5d8cccfbed0",
        "storage_key": "property/6767906449167741/01a03e5c-9237-7083-9e00-b5d8cccfbed0.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.tri-rail.com/stations/cypress-creek-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16049071252587968703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-creek",
      "poi_latitude": "26.2011948",
      "poi_longitude": "-80.15036769999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-980c-74cb-a382-2bd79e052b8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-980c-74cb-a382-2bd79e052b8e",
        "storage_key": "property/6767906449167741/01a03e5a-980c-74cb-a382-2bd79e052b8e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVP-WrYD2YgRv3hwyUXBud4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_c8e6b49023f147a07520f9ca",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Broward Sheriffs Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2601 W Broward Blvd, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-993c-72a7-979e-e0ea26d9f364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-993c-72a7-979e-e0ea26d9f364",
        "storage_key": "property/6767906449167741/01a03e5c-993c-72a7-979e-e0ea26d9f364.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sheriff.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2140656554850401432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-sheriffs-office",
      "poi_latitude": "26.1224275",
      "poi_longitude": "-80.1771759",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-765-4321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-aefc-72b2-872d-0157c18a227e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-aefc-72b2-872d-0157c18a227e",
        "storage_key": "property/6767906449167741/01a03e5c-aefc-72b2-872d-0157c18a227e.webp",
        "width": 177,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2smkNAA2YgRmDz4gcsjtR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_52ae78a489d0c444721a1d29",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Holy Cross Health",
      "poi_type": "Health and Wellness",
      "poi_address": "4725 N Federal Hwy, Fort Lauderdale, FL 33308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-92b2-755f-868b-cf3200148792.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-92b2-755f-868b-cf3200148792",
        "storage_key": "property/6767906449167741/01a03e5c-92b2-755f-868b-cf3200148792.webp",
        "width": 350,
        "height": 264
      },
      "poi_business_url": "http://www.holy-cross.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7971714723990964616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-cross-health",
      "poi_latitude": "26.1866679",
      "poi_longitude": "-80.1196531",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 954-771-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-880e-7143-845c-40bc077fd630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-880e-7143-845c-40bc077fd630",
        "storage_key": "property/6767906449167741/01a03e5a-880e-7143-845c-40bc077fd630.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMRRIuBcC2YgRiIk7Nk44oW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_3b2b55b53a7d2765cb5054bd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "AutoNation",
      "poi_type": "Shopping & Retail",
      "poi_address": "200 SW 1st Ave, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "Auto dealer with 300+ locations across 18 states offering new and used cars, trucks, parts, and auto repair services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-9711-728d-8325-07c325c1f306.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9711-728d-8325-07c325c1f306",
        "storage_key": "property/6767906449167741/01a03e5c-9711-728d-8325-07c325c1f306.webp",
        "width": 1280,
        "height": 1092
      },
      "poi_business_url": "https://www.autonation.com/?&utm_source=local&utm_medium=organic&utm_campaign=*000012247*GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962422748435937588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "autonation",
      "poi_latitude": "26.1200646",
      "poi_longitude": "-80.1441231",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 954-769-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-881b-7076-b59b-44d35b91de29",
        "storage_key": "property/6767906449167741/01a03e5a-881b-7076-b59b-44d35b91de29.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI0r2aFgA2YgRNHlnNwHsYHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_dealer"
    },
    {
      "id": "ec_a9198ee7c2ab9a89db56b918",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Chewy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1855 Griffin Rd Ste B-428, Dania Beach, FL 33004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-98f7-7124-a5ca-a29d0e91ac4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-98f7-7124-a5ca-a29d0e91ac4d",
        "storage_key": "property/6767906449167741/01a03e5c-98f7-7124-a5ca-a29d0e91ac4d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chewy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=165156316283857781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chewy",
      "poi_latitude": "26.0594381",
      "poi_longitude": "-80.1615227",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 954-793-4142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8b15-747c-b123-2f19ac25ecb3",
        "storage_key": "property/6767906449167741/01a03e5a-8b15-747c-b123-2f19ac25ecb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5yPM5Jmr2YgRdeuCbMvASgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_cb38e2a6c133ca19bd204663",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Nova Southeastern University",
      "poi_type": "Education",
      "poi_address": "3300 S University Dr, Fort Lauderdale, FL 33328, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e59-0ad3-729b-bf65-87c882590ad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-0ad3-729b-bf65-87c882590ad3",
        "storage_key": "property/6767906449167741/01a03e59-0ad3-729b-bf65-87c882590ad3.webp",
        "width": 1280,
        "height": 951
      },
      "poi_business_url": "http://www.nova.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12169842592624840886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nova-southeastern-university",
      "poi_latitude": "26.0791417",
      "poi_longitude": "-80.2465466",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-541-6682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8d31-714b-9f9d-f461e6d1df06",
        "storage_key": "property/6767906449167741/01a03e5a-8d31-714b-9f9d-f461e6d1df06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP64CCSWo2YgRtpDSAVz346g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_60fb124743f8165c6bc5be92",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "poi_name": "Broward County Governmental Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "115 S Andrews Ave, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-a899-7637-affe-f43d89affe6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a899-7637-affe-f43d89affe6a",
        "storage_key": "property/6767906449167741/01a03e5c-a899-7637-affe-f43d89affe6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.broward.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10438013078851339141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-county-governmental-center",
      "poi_latitude": "26.1209754",
      "poi_longitude": "-80.1439666",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 954-831-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167741/01a03e5c-aefc-72b2-872d-061517eaf9b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-aefc-72b2-872d-061517eaf9b1",
        "storage_key": "property/6767906449167741/01a03e5c-aefc-72b2-872d-061517eaf9b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbNMvfgA2YgRhcPQnZdF25A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_4378fb5991fd24c1728f2f83",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5fdbfb7b1bc80adcc4ac208a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e6e1dcbaa9c7599d67135a86",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9e26554a7a6a684d4cf7fa1b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4d76b9dcb260f132201a89a8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d4d8b8d5427b1df8af043d46",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_36bc152bb5eac5b5843a4fb4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "rating": "5",
      "name": "Jer Elliott",
      "text": "I had a great experience touring The Pearl Apartments. The community was beautiful, clean, and well-maintained. What really stood out was the excellent customer service I received from Esther. She was friendly, professional, and very knowledgeable. She took the time to answer all of my questions, explained everything thoroughly, and made the entire tour feel relaxed and welcoming. Esther truly went above and beyond to make sure I had a great experience. I’m looking forward to calling The Pearl Apartments my new home!",
      "date": "2026-07-14",
      "title": "false"
    },
    {
      "id": "ec_b821e83e089b819fc3bf9730",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "rating": "5",
      "name": "Brandi Pope",
      "text": "I had an appointment with Mannie on Saturday. He was so nice and helpful. Showed me a beautiful 2/2 that we are planning to move in at the end of the month. Just waiting on the rental verification. He’s really made the whole process smooth. I highly recommend these apartments. Ask for manni. He’ll take care of you!",
      "date": "2026-03-09",
      "title": "false"
    },
    {
      "id": "ec_954a52c46a2e8a3ff746c0ad",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "rating": "5",
      "name": "Abigail Ruiz",
      "text": "I would first like to recognize Esther(my go-to person when I have any issues or questions) for the excellent service she provides to our community. She is always professional, friendly, and willing to help whenever I have questions or concerns. She takes the time to listen, responds promptly, and makes me feel valued and respected. I would also like to praise Manny for his welcoming smile and positive attitude every time my family and I visit the clubhouse, it is quite refreshing.\n\nBritt & Adrian(Maintenance Staff) are both amazing, kind and helpful. They quickly get stuff done and go above and beyond during and after work hours.\n\nWe have been living at the Pearl for almost 5 years now, having seen staff come and go, but I’m happy with who we have here now.  I want to Thank you all, for your outstanding service and for all that you do to make our community better each day.",
      "date": "2026-06-12",
      "title": "false"
    },
    {
      "id": "ec_3b06385736042c59c4c0d4bb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "rating": "5",
      "name": "Alexis Allen",
      "text": "The property is beautiful, the pool is gorgeous, and everything is always clean and well maintained. Best of all, what you see is actually what you get.\n\nOne thing I really appreciate is the communication. Whether something is changing, being updated, or just needs an announcement, they keep everyone informed. You're never left wondering what's going on.\n\nIf you're looking for an apartment where the process is easy, the property is beautiful, and the staff deserves a trophy for patience, this is your place. Thank you to our leasing office team been here 6 years and I love it. Ms. Esther and Manny I love u guys.",
      "date": "2026-06-19",
      "title": "false"
    },
    {
      "id": "ec_7d49fda1e760835dda040dd7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "rating": "5",
      "name": "A Global",
      "text": "Esther is truly one of the highlights of living at The Pearl apartment community. She is consistently sweet, kind, and thoughtful in every interaction, and you can genuinely feel that she cares about the residents here.\n\nWhat stands out most is how welcoming and inviting she is. She has a way of making the community feel warm and approachable, not just like a place you live, but a place that feels like home. Whether it’s a quick greeting or a longer conversation, she always brings a positive and friendly energy that makes your day a little better.\n\nEsther adds a real sense of heart to The Pearl, and it’s clear she plays a big role in making the community feel so homey and well cared for.",
      "date": "2026-06-30",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "apartments-with-pool-fort-lauderdale-prestige",
      "search_query": "apartments with pool Fort Lauderdale",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Fort Lauderdale",
      "h2_subtitle": "Discover luxury living with a pool at Prestige. Our Fort Lauderdale community offers top-notch amenities you’ll love.",
      "page_copy": "Experience the ultimate in South Florida living at Prestige, conveniently located in the vibrant Palm Aire neighborhood of Fort Lauderdale. Our apartments not only offer modern comforts, such as stainless steel appliances and vinyl flooring, but also feature a sparkling pool perfect for relaxation and fun.\n\nWhether you’re taking a dip, enjoying a stroll on the walking/biking trails, or utilizing the controlled access amenities, Prestige has everything you need. Plus, with an in-unit washer/dryer, our apartments with pool Fort Lauderdale ensure a convenient lifestyle. Live the Prestige experience today and embrace comfort and luxury.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Fort Lauderdale - Prestige",
      "seo_description": "Find your dream apartment with a pool at Prestige in Fort Lauderdale. Enjoy modern amenities and a prime location in Palm Aire.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "washer-dryer-in-unit-fort-lauderdale-fl-prestige",
      "search_query": "washer dryer in unit Fort Lauderdale FL",
      "category": "Amenity",
      "h1_title": "Washer Dryer in Unit Fort Lauderdale, FL",
      "h2_subtitle": "Find comfort and convenience with in-unit washer dryer at Prestige. Located in Fort Lauderdale, FL.",
      "page_copy": "At Prestige, we redefine convenience and comfort in the heart of Fort Lauderdale, FL. Each apartment includes a washer dryer in unit, ensuring laundry day is a breeze. Say goodbye to trips to the laundromat and hello to more free time.\n\nNestled in the cozy Palm Aire neighborhood, Prestige offers more than just luxurious living spaces. From stainless steel appliances to beautiful vinyl flooring, our amenities are designed to fit your lifestyle. With controlled access and nearby walking/biking trails, Prestige is your gateway to modern living in Broward County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer in Unit Fort Lauderdale, FL - Prestige",
      "seo_description": "Enjoy the convenience of in-unit washer dryer at Prestige in Fort Lauderdale, FL. Discover modern amenities and a prime location in our community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-dishwasher-broward-county-prestige",
      "search_query": "luxury apartments with dishwasher Broward County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Dishwasher in Broward",
      "h2_subtitle": "Prestige offers luxury apartments with dishwasher in Broward County. Experience upscale living with our exceptional amenities.",
      "page_copy": "Discover the comfort of luxury living at Prestige, where our stunning apartments come equipped with a dishwasher, enhancing your daily convenience. Located in vibrant Broward County, Prestige provides a blend of style and functionality.\n\nOur community doesn’t just stop at superb interior features; we also offer stainless steel appliances, vinyl flooring, and controlled access, ensuring a seamless lifestyle. Enjoy the walking/biking trails around the neighborhood and experience all the perks of living in the heart of Fort Lauderdale’s Palm Aire area. Elevate your living experience at Prestige today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Dishwasher in Broward",
      "seo_description": "Elevate your living at Prestige in Broward County. Our luxury apartments include a dishwasher and premium features in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "apartments-with-playground-palm-aire-prestige",
      "search_query": "apartments with playground Palm Aire",
      "category": "Amenity",
      "h1_title": "Apartments with Playground in Palm Aire",
      "h2_subtitle": "Discover family-friendly apartments with playground at Prestige. Located in the Palm Aire neighborhood.",
      "page_copy": "Live in family-friendly comfort at Prestige, where you'll find delightful apartments with a playground in Fort Lauderdale's sought-after Palm Aire neighborhood. Our community caters to all ages, offering a welcoming space for everyone.\n\nBesides a vibrant playground, Prestige is equipped with fabulous amenities like stainless steel appliances, vinyl flooring, and an in-unit washer/dryer. With walking/biking trails just steps away, experience the blend of outdoor joy and convenient living in beautiful Broward County. Choose Prestige for a balanced lifestyle in Palm Aire.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Playground in Palm Aire - Prestige",
      "seo_description": "Explore family-friendly apartments with a playground at Prestige, nestled in the Palm Aire area. Enjoy premium amenities and a prime Fort Lauderdale location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "apartments-near-tennis-court-fort-lauderdale-prestige",
      "search_query": "apartments near tennis court in Fort Lauderdale",
      "category": "Amenity",
      "h1_title": "Apartments Near Tennis Court Fort Lauderdale",
      "h2_subtitle": "Experience active living in our apartments near tennis courts at Prestige. Conveniently located in Fort Lauderdale.",
      "page_copy": "Discover active living at Prestige, where our apartments are conveniently located near tennis courts in Fort Lauderdale. Perfect for enthusiasts seeking fitness and fun, our community offers easy access to local sports facilities.\n\nPrestige not only offers proximity to tennis courts but also features luxurious in-unit amenities such as a washer/dryer, stainless steel appliances, and vinyl flooring. Nestled in the scenic Palm Aire neighborhood, enjoy nearby walking/biking trails and all that vibrant Broward County has to offer. Join us at Prestige for an active lifestyle in a prime location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tennis Court in Fort Lauderdale, FL",
      "seo_description": "Live near tennis courts at Prestige, offering luxury amenities and an ideal Fort Lauderdale location. Enjoy an active lifestyle in Broward County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "one-bedroom-apartment-palm-aire-prestige",
      "search_query": "one bedroom apartment palm aire",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartment in Palm Aire",
      "h2_subtitle": "Explore spacious one bedroom apartments at Prestige in Palm Aire. Perfectly situated in a vibrant Fort Lauderdale neighborhood.",
      "page_copy": "Find your ideal retreat at Prestige, featuring stylish one bedroom apartments in the charming Palm Aire neighborhood of Fort Lauderdale. Our community provides a perfect balance of comfort and convenience.\n\nEach one bedroom apartment boasts modern amenities including a washer/dryer, stainless steel appliances, and attractive vinyl flooring. With controlled access and nearby walking/biking trails, Prestige offers an exceptional living experience in Broward County. Discover a welcoming home and an enriching lifestyle at Prestige today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartment in Palm Aire, Fort Lauderdale",
      "seo_description": "Discover modern one bedroom apartments at Prestige in Palm Aire. Enjoy premium amenities and prime Fort Lauderdale location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "apartments-near-nova-southeastern-university-prestige",
      "search_query": "apartments near nova southeastern university fort lauderdale",
      "category": "School",
      "h1_title": "Apartments Near Nova Southeastern University",
      "h2_subtitle": "Find convenient apartments near Nova Southeastern University at Prestige. Located in Fort Lauderdale's vibrant Palm Aire neighborhood.",
      "page_copy": "Experience convenient living at Prestige, offering ideal apartments near Nova Southeastern University in Fort Lauderdale. Whether you're a student or staff, our location in the Palm Aire neighborhood provides both accessibility and a vibrant community.\n\nEnjoy modern living with features like in-unit washer/dryers, stainless steel appliances, and sleek vinyl flooring. Additionally, Prestige is surrounded by lush walking/biking trails and provides controlled access, making it a prime choice in Broward County for those affiliated with the university. Join us at Prestige today and enjoy a supportive and dynamic environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Nova Southeastern University, FL",
      "seo_description": "Live close to Nova Southeastern University at Prestige. Enjoy top amenities in the Palm Aire area of Fort Lauderdale, perfect for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "apartments-close-broward-college-central-campus-prestige",
      "search_query": "apartments close to broward college central campus palm aire",
      "category": "School",
      "h1_title": "Apartments Close to Broward College",
      "h2_subtitle": "Discover apartments close to Broward College Central Campus at Prestige. Conveniently located in Palm Aire, Fort Lauderdale.",
      "page_copy": "Welcome to Prestige, where our apartments are ideally situated close to Broward College Central Campus in the vibrant Palm Aire area of Fort Lauderdale. Perfect for students and faculty, our community offers the perfect blend of comfort and convenience.\n\nEnjoy premium amenities such as washer/dryers, stainless steel appliances, and modern vinyl flooring in each unit. Additionally, Prestige boasts controlled access and scenic walking/biking trails nearby, making it the ideal choice for those seeking proximity to the College and an enriching living experience within Broward County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Broward College Central Campus",
      "seo_description": "Live near Broward College Central Campus at Prestige in Palm Aire. Enjoy convenient student living with top amenities in Fort Lauderdale.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "apartments-near-hca-florida-westside-hospital-prestige",
      "search_query": "apartments near HCA Florida Westside Hospital Fort Lauderdale",
      "category": "Hospital",
      "h1_title": "Apartments Near HCA Florida Westside Hospital",
      "h2_subtitle": "Explore convenient living options at Prestige, offering apartments near HCA Florida Westside Hospital in Fort Lauderdale's Palm Aire neighborhood.",
      "page_copy": "At Prestige, you can find the perfect home with our well-appointed apartments near HCA Florida Westside Hospital in Fort Lauderdale. Located in the heart of Palm Aire, our community is ideal for healthcare professionals and hospital visitors seeking a comfortable and convenient place to call home.\n\nOur apartments offer modern amenities such as washer/dryers, stainless steel appliances, and elegant vinyl flooring. The community features controlled access and nearby walking/biking trails for leisure and relaxation. Choose Prestige for an unparalleled blend of accessibility and modern living in Broward County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near HCA Florida Westside Hospital",
      "seo_description": "Discover comfortable living at Prestige, near HCA Florida Westside Hospital. Located in Palm Aire, Fort Lauderdale with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "apartments-near-hugh-taylor-birch-state-park-prestige",
      "search_query": "apartments near Hugh Taylor Birch State Park Fort Lauderdale",
      "category": "Park",
      "h1_title": "Apartments Near Hugh Taylor Birch State Park",
      "h2_subtitle": "Discover the advantages of living at Prestige, with apartments near Hugh Taylor Birch State Park in Fort Lauderdale's vibrant Palm Aire area.",
      "page_copy": "Experience the ideal blend of nature and city life at Prestige, where our apartments are beautifully situated near Hugh Taylor Birch State Park in Fort Lauderdale. Located in the lively Palm Aire neighborhood, our community offers easy access to one of the city's most beloved natural spots.\n\nAt Prestige, enjoy upscale living with amenities like in-unit washer/dryers, stainless steel appliances, and stylish vinyl flooring. Our controlled access community also features nearby walking and biking trails for those who love the outdoors. Choose Prestige and live where convenience meets nature in Broward County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hugh Taylor Birch State Park",
      "seo_description": "Live near Hugh Taylor Birch State Park at Prestige. Offering modern amenities in Fort Lauderdale's Palm Aire neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "rentals-close-to-riverwalk-fort-lauderdale-prestige",
      "search_query": "rentals close to Riverwalk Fort Lauderdale Broward County",
      "category": "Park",
      "h1_title": "Rentals Close to Riverwalk Fort Lauderdale",
      "h2_subtitle": "Explore the perfect rentals close to Riverwalk Fort Lauderdale at Prestige. Experience vibrant living within Broward County.",
      "page_copy": "Located in the vibrant Palm Aire neighborhood, Prestige offers exceptional rentals close to the enchanting Riverwalk Fort Lauderdale. Ideal for those who appreciate the blend of city excitement and serene waterfront views, our community provides unmatched access to this iconic attraction in Broward County.\n\nPrestige boasts upscale amenities including stainless steel appliances, washer/dryers, and sleek vinyl flooring within each unit. Our community ensures security with controlled access and offers serene walking/biking trails nearby. Choose Prestige for a modern, convenient lifestyle near the heart of Fort Lauderdale.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Riverwalk Fort Lauderdale",
      "seo_description": "Find stylish rentals at Prestige near Riverwalk Fort Lauderdale. Perfectly located in Broward County with superior amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "palm-aire-apartments-near-tree-tops-park-prestige",
      "search_query": "Palm Aire apartments near Tree Tops Park FL",
      "category": "Park",
      "h1_title": "Palm Aire Apartments Near Tree Tops Park",
      "h2_subtitle": "Experience tranquil living at Prestige with Palm Aire apartments near Tree Tops Park, offering great amenities and a peaceful environment.",
      "page_copy": "Nestled within the tranquil Palm Aire neighborhood, Prestige provides exquisite apartments near Tree Tops Park, FL. Our community is perfect for those who cherish the peace of nature while still being close to urban conveniences in Broward County.\n\nPrestige apartments feature premium amenities such as stainless steel appliances, in-unit washer/dryers, and modern vinyl flooring. Enjoy a secure, controlled access environment and take advantage of nearby walking and biking trails. Embrace a harmonious lifestyle at Prestige, where comfort meets nature just a short drive from Tree Tops Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Palm Aire Apartments Near Tree Tops Park",
      "seo_description": "Discover Palm Aire living at Prestige, near Tree Tops Park. Enjoy modern amenities and a serene environment in Broward County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "prestige-apartments-by-snyder-park-fort-lauderdale",
      "search_query": "Prestige apartments by Snyder Park in Fort Lauderdale",
      "category": "Park",
      "h1_title": "Prestige Apartments by Snyder Park",
      "h2_subtitle": "Discover the charm of Prestige apartments located by Snyder Park in Fort Lauderdale, providing a perfect balance of nature and modern amenities.",
      "page_copy": "At Prestige, enjoy the best of both worlds with our apartments situated near Snyder Park in Fort Lauderdale. This ideal location allows residents to relish the beauty of green spaces, as well as the convenience of city living in Broward County's Palm Aire neighborhood.\n\nOur spacious apartments offer top-tier amenities, including stainless steel appliances, washer/dryers, and chic vinyl flooring. The community is designed with security in mind, featuring controlled access, and is perfectly complemented by nearby walking and biking trails. Live at Prestige and savor the vibrant lifestyle near Snyder Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prestige Apartments by Snyder Park",
      "seo_description": "Live at Prestige near Snyder Park, Fort Lauderdale. Enjoy modern amenities and a prime location in Palm Aire.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167741",
      "source": "generator",
      "page_item_url": "mills-pond-park-nearby-apartments-33312-prestige",
      "search_query": "Mills Pond Park nearby apartments in zip code 33312",
      "category": "Park",
      "h1_title": "Mills Pond Park Nearby Apartments 33312",
      "h2_subtitle": "Explore convenient living at Prestige, offering apartments in zip code 33312 near Mills Pond Park, ideal for outdoor enthusiasts.",
      "page_copy": "Situated in the vibrant region of zip code 33312, Prestige offers ideal apartments nearby Mills Pond Park, a haven for those who enjoy outdoor activities in Fort Lauderdale. Our community in the Palm Aire neighborhood presents a unique combination of urban comfort and nature's serenity.\n\nEach unit at Prestige is equipped with stainless steel appliances, in-unit washer/dryers, and stylish vinyl flooring, ensuring a modern lifestyle. With controlled access and nearby walking and biking trails, enjoy both security and recreation. Choose Prestige for a fulfilling living experience near Mills Pond Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mills Pond Park Nearby Apartments in 33312",
      "seo_description": "Prestige offers modern apartments in zip code 33312 near Mills Pond Park. Enjoy a blend of amenities and greenery in Fort Lauderdale.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjlCY21LZllNK09FU3M4TGxURmhHV3c9PSIsInZhbHVlIjoiZnZDZExzVThBd2xZZGpuWHVwRHZ2Zz09IiwibWFjIjoiYTM1NTIxNjIzOWMyMmExMGEwOWU2NTM0ODc4ZTU4NzNhYzE2YTRiNDdmMzBmMjkyNDRhZTNkZmZlZWFiYzBmYyJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjlCY21LZllNK09FU3M4TGxURmhHV3c9PSIsInZhbHVlIjoiZnZDZExzVThBd2xZZGpuWHVwRHZ2Zz09IiwibWFjIjoiYTM1NTIxNjIzOWMyMmExMGEwOWU2NTM0ODc4ZTU4NzNhYzE2YTRiNDdmMzBmMjkyNDRhZTNkZmZlZWFiYzBmYyJ9"
};

export const generatedAt = '2026-09-09T15:23:02.509Z';
